// function throttle (callback, limit) {
//     var wait = false;                 // Initially, we're not waiting
//     return function () {              // We return a throttled function
//         if (!wait) {                  // If we're not waiting
//             callback.call();          // Execute users function
//             wait = true;              // Prevent future invocations
//             setTimeout(function () {  // After a period of time
//                 wait = false;         // And allow future invocations
//             }, limit);
//         }
//     }
// }




function throttle(fn, threshhold, scope) {
    var last, deferTimer;
    return function () {
        var now = +new Date;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(scope);
            }, threshhold + last - now);
        } else {
            last = now;
            fn.apply(scope);
        }
    };
}

var stikyHeader = window.stikyHeader =  {
    downClass: 'header-down',
    upClass: 'header-up',
    fixedClass: 'header-fixed',

    element: null,
    isShowed: true,

    lastScrollTop: 0,
    sensitivity: 30, //
    throttleTime: 100,
    offsetTop: 50,
    _lock: false,

    init: function(element) {
        this.element = element;
        this.addEvent();
    },

    lock: function(){
        this._lock = true;
        this.show();
    },

    addEvent: function() {
        this.event = window.addEventListener('scroll', throttle(this.check, this.throttleTime, this), {passive: true});
    },

    check: function() {
        if(this._lock ){
            return;
        }

        var scrollTop = document.documentElement.scrollTop;
        // handle sensitivity
        if(Math.abs(this.lastScrollTop - scrollTop) < this.sensitivity){
            return;
        }
        var isScrolledUp = scrollTop < this.lastScrollTop;
        var isScrolledDown = !isScrolledUp;
        this.lastScrollTop = scrollTop;


        var isTop = scrollTop < this.offsetTop ; // this.offsetTop;


        if(this.isShowed && isScrolledDown && !isTop){
            this.hide();
            return;
        }

        //show when
        if(!this.isShowed && (isScrolledUp || isTop)){
            this.show();
            return;
        }

    },

    show: function(){
        // console.log('slide down');
        this.isShowed = true;
        var classList = this.element.classList;
        window.requestAnimationFrame(function(){
            classList.remove(this.upClass);
            classList.add(this.downClass);
        }.bind(this))
    },

    hide: function(){
        this.isShowed = false;
        var classList = this.element.classList;
        window.requestAnimationFrame(function() {
            classList.remove(this.downClass);
            classList.add(this.upClass);
        }.bind(this));
    }

}

stikyHeader.init(document.getElementById('header'));

window.initStikyHeader = function(){
    stikyHeader.init(document.getElementById('header'));
}


// var stickyAside = {
//     all: [],
//     add: function(){
//
//     }
// }
//
//
// stickyAside.add({
//     element: '',
//     parent: '',
// })


// WEBPACK FOOTER //
// ./Resources/assets/js/header-scroll.js